import React, { Component } from "react";
import "./style.css";
import { connect } from "react-redux";
import Modal from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';

import Button from "@material-ui/core/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import {
  getActiveStep,
  getSnackBar,
  getDynamicOptions,
  getFormInitialized,
  getFormFiles,
  getDynamicDisable,
  getFormValid,
  getMessage,
  getOpenModalDireccion,
  getEstadoAfiliacionCompany,
  getModalFlujos,
  getNameAnexos,
  getCambioStado,
  getPopSeeAnexos,
  getModalNumProcess,
  getOpenModalCharged,
  getOpenModalFinal,
  getActiveFormRya,
  getCleanAutoComplete,
  getTamanioFiles,
  getValidRnecRepLegal,
  getEditInfoFromBandeja,
  getChangeComponentId,
  getOpenFormManualWorkers,
} from "./selectors";

import {
  UPDATE_FIELD_ATTRIBUTE,
  getSubmitButtonss,
  getSubmitButtons,
  FORM_NAME_STEP1,
  FORM_NAME_STEP2,
  FORM_NAME_STEP3,
  FORM_NAME_STEP4,
  FORM_NAME_STEP5,
  INCREASE_STEP,
  SALVAR_STEP,
  DECREASE_STEP,
  HANDLE_STEP,
  STEPS_CONTENT,
  LOAD_CATALOG,
  getInitButtons,
  ARCHIVOS_ADJUNTOS,
  getStep1Form,
  getStep2Form,
  getStep3Form,
  getStep4Form,
  getStep5Form,
  CLOSE_MODAL_DIRECCION,
  CREATE_DIRECCION_MODAL,
  OPEN_MODAL_DIRECCION,
  getAfiliacionCompanyForm,
  VALIDA_AFILIACION_COMPANY,
  getAfiliacionButtons,
  GESTION_PERSONAL_ADMIN,
  FORM_NAME_STEP_PRINCIPAL,
  CLOSE_MODAL_FLUJOS,
  UPLOAD_ANEXOS,
  REMOVE_ANEXOS,
  SEE_ANEXOS,
  CLOSED_POPUP_ADJUNTOS,
  getModalNumProcesos,
  FORM_NAME_NUM_PROCESS,
  CLOSE_MODAL_NUM_PROCESS,
  VALIDATE_NUM_PROCESS,
  FORM_NAME_STEP0,
  getAddSend,
  CLOSE_MODAL_FINAL,
  OPEN_VALIDATE_ANEXOS,
  UNLOCK_PERSONA_NATURAL,
  getStep0FormJuridico,
  getStep1FormBandeja,
  DOWNLOAD_RELATION_WORKERS,
  FORM_NAME_STEP_RELATIONSHIP_WORKERS,
  getRelationsWorkersForm,
  UPLOAD_RELATIONS_WORKERS,
  GESTION_WORKERS_COMPANY,
  getRelationsWorkersFormManual,
} from "./constants";

import CustomForm from "../../components/materialform/customform";
import MuiAlert from "@material-ui/lab/Alert";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

import { getFromSession } from "../../controller/session";

import { ComponetTerminos } from "../../components/materialform/terminos";
import { validateRelationWorkers, validateStep0, validateStep1, validateStep2, validateStep3, validateStep4, validateStepPrincipal } from "./controllerEmpresas";

class ComponentFormJuridico extends Component {
  componentDidMount() {

    // loadCatalog();
  }

  componentDidUpdate(prevProps) {
    const { activeStep } = this.props;
    if (activeStep !== prevProps.activeStep) {
      // document.body.scrollTop = -100;
      // document.documentElement.scrollTop = -100;
      window.scrollTo(0, 0);
    }

  }

  showSnackBar(open, message) {
    return (
      <Snackbar open={open} autoHideDuration={1} className="ocultar">
        <Alert severity="success">{message}</Alert>
      </Snackbar>
    );
  }

  modalSubmitValid(props) {
    const { modalFlujos, closeModalFlujos } = props;

    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
      >
        <div className="messageSucess">
          <React.Fragment>
            {modalFlujos.error ? <Alert className="alert danger">
              {modalFlujos.message}
            </Alert>
              :
              <Alert className="alertsucessBorrador" >
                {modalFlujos.message}
              </Alert>
            }
          </React.Fragment>


          <div>
            <Button
              className='buttonFinalizar'
              variant="text"
              color="default"
              onClick={() => closeModalFlujos()}
            >
              Aceptar
            </Button>
          </div>


        </div>
      </Modal>
    );
  }


  modalNumeroProceso(props) {
    const { validarNumProcess, closeModalNumProcess, dynamicOptions } = props;

    return (
      <div className="modalProcessNum">
        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          open
        >
          <React.Fragment>
            <CustomForm
              submitable={false}
              items={getModalNumProcesos()}
              formName={FORM_NAME_NUM_PROCESS}
              //validations={this.validateStep6}
              handleSubmit={() => validarNumProcess()}
              buttons={getAddSend(
                () => closeModalNumProcess(),
                () => validarNumProcess()
              )}
              dynamicOptions={dynamicOptions}
              className="formProcessNum"
            />
          </React.Fragment>


        </Modal>
      </div>
    );
  }

  modalEsperaCharged() {

    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
      >
        <div className="modalEsperaCharged">
          <CircularProgress style={{ width: '70px', height: '70px' }} />
        </div>
      </Modal>
    );
  }

  getStepPrincipal(props) {
    const { validaAfiliacion, dynamicOptions, dynamicDisable } = props;

    return (
      <React.Fragment>
        <CustomForm
          submitable={false}
          items={getAfiliacionCompanyForm()}
          formName={FORM_NAME_STEP_PRINCIPAL}
          validations={validateStepPrincipal}
          handleSubmit={() => validaAfiliacion()}
          buttons={getAfiliacionButtons(() => validaAfiliacion)}
          dynamicOptions={dynamicOptions}
          dynamicDisable={dynamicDisable}
          className="people-form"
        />
      </React.Fragment>
    );
  }

  modalSubmitConfirmation(props) {
    return (<ComponetTerminos />)
  }

  getStepContent(props) {
    const {
      activeStep,
      increaseStep,
      decreaseStep,
      openSubmitModal,
      formFiles,
      salvarStep,
      modalDireccion,
      dynamicOptions,
      gestionPersonalAdmin,
      gestionTrabajadoresCompany,
      handleUploadAnexo,
      handleRemoveAnexo,
      handleSeeAnexo,
      nameAnexos,
      newEstado,
      dynamicDisable,
      activeFormRya,
      validRnecRepLegal,
      editInfoFromBandeja,
      cleanAutoComplete,
      tamanioFiles,
      changeComponentId,
      downloadRelationWorkers,
      uploadRelationWorkers,
      openFormManualWorkers,
    } = props;

    switch (activeStep) {
      case 0:
        return (
          <React.Fragment>
            <CustomForm
              submitable={false}
              items={getStep0FormJuridico()}
              formName={FORM_NAME_STEP0}
              validations={validateStep0}
              handleSubmit={() => increaseStep()}
              buttons={getInitButtons(() => increaseStep)}
              dynamicOptions={dynamicOptions}
              activeFormRya={activeFormRya}
              dynamicDisable={dynamicDisable}
              className="people-form"
            />
          </React.Fragment>
        );
      case 1:
        return (
          <React.Fragment>
            <CustomForm
              submitable={false}
              items={activeFormRya ? getStep1FormBandeja(gestionPersonalAdmin) : getStep1Form(gestionPersonalAdmin)}
              formName={FORM_NAME_STEP1}
              validations={validateStep1}
              handleSubmit={() => increaseStep()}
              buttons={getSubmitButtonss(
                () => decreaseStep(),
                () => increaseStep()
              )}
              className="informacion-basica-form"
              dynamicOptions={dynamicOptions}
              dynamicDisable={dynamicDisable}
              editInfoFromBandeja={editInfoFromBandeja}
              activeFormRya={activeFormRya}
              cleanAutoComplete={cleanAutoComplete}
              changeComponentId={changeComponentId}
            />
          </React.Fragment>
        );
      case 2:
        return (
          <React.Fragment>
            <CustomForm
              submitable={false}
              validations={validateStep2}
              items={getStep2Form()}
              formName={FORM_NAME_STEP2}
              handleSubmit={() => increaseStep()}
              buttons={getSubmitButtonss(
                () => decreaseStep(),
                () => increaseStep()
              )}
              modalDireccion={modalDireccion}
              dynamicOptions={dynamicOptions}
              dynamicDisable={dynamicDisable}
              activeFormRya={activeFormRya}
              cleanAutoComplete={cleanAutoComplete}
              className="informacion-basica-form"
            />
          </React.Fragment>
        );
      case 3:
        return (
          <React.Fragment>
            <CustomForm
              submitable={false}
              items={getStep3Form(modalDireccion)}
              validations={validateStep3}
              formName={FORM_NAME_STEP3}
              handleSubmit={() => increaseStep()}
              buttons={getSubmitButtonss(
                () => decreaseStep(),
                () => increaseStep()
              )}
              className="informacion-basica-form"
              dynamicOptions={dynamicOptions}
              dynamicDisable={dynamicDisable}
              activeFormRya={activeFormRya}
              cleanAutoComplete={cleanAutoComplete}
            />
          </React.Fragment>
        );

      case 4:
        return (
          <React.Fragment>
            <CustomForm
              submitable={false}
              items={getStep4Form()}
              formName={FORM_NAME_STEP4}
              validations={validateStep4}
              handleSubmit={() => increaseStep()}
              buttons={getSubmitButtonss(
                () => decreaseStep(),
                () => increaseStep()
              )}
              dynamicOptions={dynamicOptions}
              dynamicDisable={dynamicDisable}
              activeFormRya={activeFormRya}
              validRnecRepLegal={validRnecRepLegal}
              cleanAutoComplete={cleanAutoComplete}
              changeComponentId={changeComponentId}
              className="people-form"
            />
          </React.Fragment>
        );
      case 5:
        return (
          <React.Fragment>
            <CustomForm
              submitable={false}
              items={openFormManualWorkers ? getRelationsWorkersFormManual(gestionTrabajadoresCompany) : getRelationsWorkersForm(downloadRelationWorkers, uploadRelationWorkers, gestionTrabajadoresCompany)}
              formName={FORM_NAME_STEP_RELATIONSHIP_WORKERS}
              validations={validateRelationWorkers}
              handleSubmit={() => increaseStep()}
              buttons={getSubmitButtonss(
                () => decreaseStep(),
                () => increaseStep()
              )}
              dynamicOptions={dynamicOptions}
              dynamicDisable={dynamicDisable}
              activeFormRya={activeFormRya}
              nameAnexos={nameAnexos}
              validRnecRepLegal={validRnecRepLegal}
              changeComponentId={changeComponentId}
              className="people-form"
            />
          </React.Fragment>
        );

      case 6:
        return (
          <React.Fragment>
            <CustomForm
              submitable={false}
              items={getStep5Form()}
              formName={FORM_NAME_STEP5}
              handleSubmit={() => openSubmitModal()}
              buttons={getSubmitButtons(
                () => decreaseStep(),
                () => salvarStep({ formFiles }),
                () => openSubmitModal()
              )}
              formTitle={ARCHIVOS_ADJUNTOS}
              className="people-form"
              dynamicOptions={dynamicOptions}
              dynamicDisable={dynamicDisable}
              handleUploadAnexo={handleUploadAnexo}
              handleRemoveAnexo={handleRemoveAnexo}
              handleSeeAnexo={handleSeeAnexo}
              nameAnexos={nameAnexos}
              activeFormRya={activeFormRya}
              newEstado={newEstado}
              tamanioFiles={tamanioFiles}
            />
          </React.Fragment>
        );


      default:
        return (
          <MuiAlert elevation={7} variant="filled" severity="info">
            Formulario en construcción
          </MuiAlert>
        );
    }
  }

  render() {
    const {
      activeStep,
      handleStep,
      showSnackBar,
      formInitialized,
      popSeeAnexos,
      modalNumProcess,
      openModalCharged,
      openModalFinal,
      activeFormRya,


    } = this.props;

    const authUser = getFromSession('authUser');


    if (!formInitialized && authUser) {

    }

    return (
      <React.Fragment >

        {/* {modalFlujos.open ? this.modalSubmitValid(this.props) : ''} */}
        {modalNumProcess ? this.modalNumeroProceso(this.props) : ""}
        {openModalCharged ? this.modalEsperaCharged() : ""}
        {openModalFinal ? this.modalSubmitConfirmation(this.props) : ""}

        {/* {!estadoAfiliacionCompany ? this.getStepPrincipal(this.props) : */}
        <React.Fragment>
          <Stepper className="stepper-form" activeStep={activeStep}>
            {STEPS_CONTENT.map((label, index) => {
              const stepProps = {};
              return (
                <Step key={label} {...stepProps} className={"stepEmp"}>

                  {activeFormRya ?
                    <Button
                      key={label} {...stepProps}
                      color={"secondary"}
                      className={"stepButtEmp"}

                    >
                      <h1 className="numButtEmp">{index + 1}</h1>
                      <h3 className="name-button-step">{label}</h3>
                    </Button>
                    :
                    <Button
                      key={label} {...stepProps}
                      color={"secondary"}
                      className={"stepButtEmp"}
                      onClick={() => handleStep(index)}
                    >
                      <h1 className="numButtEmp">{index + 1}</h1>
                      <h3 className="name-button-step">{label}</h3>
                    </Button>
                  }
                </Step>
              );
            })}
          </Stepper>
        </React.Fragment>
        {this.getStepContent(this.props)}

        {showSnackBar ? this.showSnackBar(
          showSnackBar,
          "Sucess"
        ) : ""}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activeStep: getActiveStep(state),
    showSnackBar: getSnackBar(state),
    dynamicOptions: getDynamicOptions(state),
    dynamicDisable: getDynamicDisable(state),
    formInitialized: getFormInitialized(state),
    formFiles: getFormFiles(state),
    message: getMessage(state),
    formValid: getFormValid(state),
    openModalDireccion: getOpenModalDireccion(state),
    estadoAfiliacionCompany: getEstadoAfiliacionCompany(state),
    modalFlujos: getModalFlujos(state),
    nameAnexos: getNameAnexos(state),
    newEstado: getCambioStado(state),
    popSeeAnexos: getPopSeeAnexos(state),
    modalNumProcess: getModalNumProcess(state),
    openModalCharged: getOpenModalCharged(state),
    openModalFinal: getOpenModalFinal(state),
    activeFormRya: getActiveFormRya(state),
    cleanAutoComplete: getCleanAutoComplete(state),
    tamanioFiles: getTamanioFiles(state),
    validRnecRepLegal: getValidRnecRepLegal(state),
    editInfoFromBandeja: getEditInfoFromBandeja(state),
    changeComponentId: getChangeComponentId(state),
    openFormManualWorkers: getOpenFormManualWorkers(state),
  };
};

const mapDispachToProps = (dispatch) => {
  return {
    updateAttributes: (value) =>
      dispatch({ type: UPDATE_FIELD_ATTRIBUTE, value }),
    increaseStep: (value) => dispatch({ type: INCREASE_STEP, value }),
    salvarStep: (value) => dispatch({ type: SALVAR_STEP, value }),
    decreaseStep: (value) => dispatch({ type: DECREASE_STEP, value }),
    handleStep: (value) => dispatch({ type: HANDLE_STEP, value }),
    openSubmitModal: (value) => dispatch({ type: OPEN_VALIDATE_ANEXOS, value }),
    loadCatalog: (value) => dispatch({ type: LOAD_CATALOG, value }),
    closeModalDireccion: (value) => dispatch({ type: CLOSE_MODAL_DIRECCION, value }),
    createDireccionModal: (value) => dispatch({ type: CREATE_DIRECCION_MODAL, value }),
    modalDireccion: (value) => dispatch({ type: OPEN_MODAL_DIRECCION, value }),
    validaAfiliacion: (value) => dispatch({ type: VALIDA_AFILIACION_COMPANY, value }),
    gestionPersonalAdmin: (value) => dispatch({ type: GESTION_PERSONAL_ADMIN, value }),
    gestionTrabajadoresCompany: (value) => dispatch({ type: GESTION_WORKERS_COMPANY, value }),
    closeModalFlujos: (value) => dispatch({ type: CLOSE_MODAL_FLUJOS, value }),
    handleUploadAnexo: (value) => dispatch({ type: UPLOAD_ANEXOS, value }),
    handleRemoveAnexo: (value) => dispatch({ type: REMOVE_ANEXOS, value }),
    handleSeeAnexo: (value) => dispatch({ type: SEE_ANEXOS, value }),
    closeModalAdjuntos: (value) => dispatch({ type: CLOSED_POPUP_ADJUNTOS, value }),
    closeModalNumProcess: (value) => dispatch({ type: CLOSE_MODAL_NUM_PROCESS, value }),
    closeModalFinal: (value) => dispatch({ type: CLOSE_MODAL_FINAL, value }),
    validarNumProcess: (value) => dispatch({ type: VALIDATE_NUM_PROCESS, value }),
    submitFinalForm: (value) => dispatch({ type: SALVAR_STEP, value }),
    unlockPersonaNaturals: (value) => dispatch({ type: UNLOCK_PERSONA_NATURAL, value }),
    downloadRelationWorkers: (value) => dispatch({ type: DOWNLOAD_RELATION_WORKERS, value }),
    uploadRelationWorkers: (value) => dispatch({ type: UPLOAD_RELATIONS_WORKERS, value }),
  };
};

export default connect(mapStateToProps, mapDispachToProps)(ComponentFormJuridico);
